import React, { useState, useEffect } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import SearchIcon from '@mui/icons-material/Search';
import {
    Container,
    Typography,
    Grid,
    Card,
    Button,
    Divider,
    Box,
    TextField,
    IconButton,
    createTheme,
    ThemeProvider,
} from '@mui/material';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import moment from 'moment';

const jobOpenings = [
    {
        "title": "Avis de recrutement : Agents recenseurs pour le Recensement des Propriétaires des propriétés et/ou parcelles dans les centres urbains du Burundi (RPPCUB)",
        "linkPost": "https://recrutement.insbu.bi/",
        "titlePost": "✨ Postulez dès maintenant et rejoignez notre équipe !",
        "titleTdrs": "Pour plus de détails, consultez les Termes de Référence complets ",
        "linkTdrs": "/documents/marches/TDRs_pour_recrutement_des_agents_recenseurs_RPPCUB.pdf",
        "link": "/documents/marches/Avis_de_recrutement_INSBU_&_DTFCN_24_03_2026.pdf",
        "description": "L'Institut National de la Statistique du Burundi (INSBU), en partenariat avec la Direction des Titres Fonciers et du Cadastre National, lance un recrutement d'agents recenseurs pour la collecte de données dans le cadre du Recensement des Propriétaires des propriétés et/ou parcelles dans les centres urbains du Burundi (RPPCUB). Cette opération vise à améliorer la planification urbaine et la gouvernance foncière grâce à la mise en place et à l'octroi de titres de propriété numériques et sécurisés.",
        "datePublication": "24/03/2026",
        "dateFin": "31/03/2026",
    },
    {
        "title": "Avis de Recrutement : Agents Enquêteurs pour l'Enquête EICVMB 2025-2026",
        "linkPost": 'https://recrutement.insbu.bi/',
        "titlePost": "✨ Postulez dès maintenant et rejoignez notre équipe ! ",
        "titleTdrs": "Pour plus de détails, consultez les Termes de Référence complets ",
        "linkTdrs": "/documents/marches/TDRs_pour_recrutement_des_enqueteurs_de_EICVMB_2025_2026.pdf",
        "link": "/documents/marches/AVIS_DE_RECRUTEMENT_DES_AGENTS_ENQUETEURS_EICVMB_2025_2026.pdf",
        "description": "L'Institut National de la Statistique du Burundi (INSBU) recrute des agents enquêteurs expérimentés pour la collecte de données sur le terrain dans le cadre de la grande Enquête Intégrée sur les Conditions de Vie des Ménages (EICVMB). Cette mission est essentielle pour établir un diagnostic précis de la situation socio-économique des ménages burundais.",
        "requirements": `
            *Profil et Conditions Requises :
                - Être de nationalité burundaise ;
                - Détenir au minimum un diplôme de baccalauréat ou de licence ;
                - Avoir participé comme agent enquêteur à la collecte d'au moins deux enquêtes auprès des ménages ;
                - Maîtriser l'utilisation des logiciels de collecte de données (CSPro, KoboToolBox, ODK, Survey Solution, etc.) ;
                - Avoir l'âge légal de travailler selon la règlementation en vigueur au Burundi ;
                - N'avoir pas été révoqué d'un emploi public ;
                - N'avoir pas de casier judiciaire (condamnation à une peine égale ou supérieure à 6 mois) ;
                - Être disponible à travailler sur tout le territoire national pendant toute la période de l'opération ;
                - Maîtriser obligatoirement le Kirundi et le Français parlés et écrits ;
                - La maîtrise du Kiswahili parlé et écrit est un atout majeur.
        `,
        "datePublication": "18/08/2025",
        "dateFin": "29/08/2025 à 15h00",
        "additionalInfo": `
            <strong>Modalités de Candidature :</strong>
            <p>Le dépôt des candidatures se fait exclusivement en ligne sur la plateforme : <a href="https://recrutement.insbu.bi" target="_blank">recrutement.insbu.bi</a></p>
            <strong>Processus de Sélection :</strong>
            <p>Un test écrit sera organisé le <strong>02 septembre 2025</strong>. Le lieu exact (à Bujumbura) sera communiqué par voie d'affichage à l'INSBU le <strong>01 septembre 2025</strong>.</p>
            <p><em>Les Termes de Référence (TDRs) détaillés sont disponibles et affichés à la Direction Générale de l'INSBU.</em></p>
        `
    },
    {
        "title": "Appel à Manifestation d’Intérêt (Consultant Individuel – Services de Consultation)",
        "link": "/documents/marches/TdRS_Assistance_Technique_Preparatifs_Rebasage_Comptes_Nationaux_Burundi.pdf",
        "description": "L’Institut National de la Statistique du Burundi (INSBU) lance un Appel à Manifestation d’Intérêt pour le recrutement d’un consultant individuel en vue de l’élaboration de la feuille de route pour le rebasage des Comptes Nationaux du Burundi à l’année de base 2025. Le consultant accompagnera l’INSBU dans la planification, la gestion de projet et l’alignement aux lignes directrices de la CAE.",
        "requirements": `
            *Exigences minimales :
                - Diplôme d’ingénieur statisticien-économiste ou maîtrise en macroéconomie spécialisée en comptabilité nationale ou équivalent;
                - Minimum 10 ans d’expérience pratique dans la production des statistiques de la comptabilité nationale;
                - Expérience avérée comme consultant international dans le rebasage des comptes nationaux.
            *Critères de sélection :
                - Nombre d’années d’expérience en tant que cadre supérieur dans la gestion des équipes et la qualité des statistiques selon le SCN 2008;
                - Expérience en rebasage des comptes nationaux dans plusieurs pays;
                - Maîtrise parfaite du français (oral et écrit), capacité à travailler en anglais;
                - Connaissance de l’économie burundaise (atout);
                - Connaissance du logiciel ERETES (atout);
                - Qualité de la proposition technique.
            *Évaluation finale :
                - Vérification des références techniques et compétences interpersonnelles (communication, conduite de réunions, animation d’ateliers, travail sous pression).
        `,
        "datePublication": "24/07/2025",
        "dateOuverture": "24/07/2025",
        "dateFin": "13/08/2025 à 10h00 précise.",
        "contact": "ins.burundi2022@gmail.com ; ins.burundi@insbu.bi avec copie à cybar2007@gmail.com",
        "Titrecontact": " Courriel : "
    },
    {
        "title": " Avis d'Appel d'Offres Ouvert National N° DNCMP/454/F/2024-2025 - Fourniture des uniformes.",
        "link": "/documents/marches/AVISLAFOURNITUREDESUNIFORMES.pdf",
        "description": "L'Institut National de la Statistique du Burundi (INSBU) lance un Appel d'Offres Ouvert National pour la fourniture des uniformes, financé sur son budget 2024-2025. Le marché comprend un lot unique à livrer dans un délai de 60 jours à Bujumbura. Les entreprises qualifiées (individuelles ou en consortium) peuvent participer sous réserve des conditions du Code des Marchés Publics. Le dossier est disponible contre paiement de 50 000 FBU, avec dépôt des offres avant le 30/04/2025 à 9h30' à la Direction Générale de l'INSBU, accompagnées d'une garantie bancaire de 510 000 FBU valable 60 jours.",
        "requirements": `
            *Capacité technique:
                - Acte d'engagement ou le formulaire de soumission dûment rempli, conformément à la clause 10 des instructions aux soumissionnaires;
                - La preuve d'achat du DAO portant le numéro du marché;
                - L' attestation originale de non-redevabilité aux impots et taxes délivrée par l'Office Burundais des Recettes (OBR) et en cours de validité ;
                - Statut (personne morale);
                - Le certificat d'Immatriculation fiscale ;
                - L' attestation originale de non-redevabilité délivree par IlNSS en cours de validité;
                - Acte d'Engagement ;
                - L'adresse précise de l'atelier de couture du soumissionnaire;
                - Registre de commerce (copie) ;
                - Garantie de soumission suivant le modèle ;
                - Attestation de non faillite délivrée par le tribunal du commerce et datant de moins de trois mois ;
                - Spéclfications techniques telles que decrites en annexe ;
            *Capacité financière :
                - Le formulaire de prix dûment rempli, conformément à la clause 9 des instructions aux soumissionnaires ;
                - Acte de soumission ;
                - Borderea ux des prix unitaires;
                - Devis quantitatif estimatif ;
                - Délai de livraison.
        `,
        "datePublication": "11/04/2024",
        "dateOuverture": "30/04/2024  à 10 heures précise.",
        "dateFin": "30/04/2025 à 9h30 avec la mention « Appel d'offre pour ta fourniture des Uniformes >>."
    },
    {
        "title": " Avis d'Appel d'Offres Ouvert National N° DNCMP/454/F/2024-2025 - Fourniture de matériel de bureau",
        "link": "/documents/marches/AVISFOURNITUREDUMATERIELDEBUREAU.pdf",
        "description": "L'Institut National de la Statistique du Burundi (INSBU) lance un Appel d'Offres Ouvert National pour la fourniture de matériel de bureau, financé sur son budget 2024-2025. Le marché comprend un lot unique à livrer dans un délai de 30 jours à Bujumbura. Les entreprises qualifiées (individuelles ou en consortium) peuvent participer sous réserve des conditions du Code des Marchés Publics. Le dossier est disponible contre paiement de 50 000 FBU, avec dépôt des offres avant le 30/04/2025 à 9h30' à la Direction Générale de l'INSBU, accompagnées d'une garantie bancaire de 750 000 FBU valable 60 jours.",
        "requirements": `
            *Capacité technique:
                - La confirmation écrite de l'habilitation du signataire à engager le soumissionnaire;
                - La preuve d'achat du DAO portant le numéro du marché;
                - L' attestation originale de non-redevabilité aux impots et taxes délivrée par l'Office Burundais des Recettes (OBR) et en cours de validité ;
                - Statut (personne morale);
                - Le certificat d'Immatriculation fiscale ;
                - L' attestation originale de non-redevabilité délivree par IlNSS en cours de validité;
                - Acte d'Engagement ;
                - Adresse fixe et connue ;
                - Registre de commerce (copie) ;
                - Garantie de soumission ;
                - Attestation de non faillite délivrée par le tribunal du commerce et datant de moins de trois mois ;
                - Specifications techniques.
            *Capacité financière :
                - Une une garantie bancaire de soumission dont le montant est fixé à sept cent cinquante mille (750 000) de francs burundais;
                - Acte de soumission ;
                - Borderea ux des prix unitaires;
                - Devis quantitatif estimatif ;
                - Délai de livraison.
        `,
        "datePublication": "11/04/2024",
        "dateOuverture": "30/04/2024",
        "dateFin": "30/04/2025 à 9h30 avec la mention << Appel d'offre pour la fourniture du matériel de buréau »."
    },
    {
        "title": "Demande de cotations pour la fourniture d'équipements divers",
        "link": '/documents/jobs/1735914404787_1735911174963_1735911005359_Demande-de-cotations-pour-la-fourniture-de-216-balances-mecaniques-216-balances-electroniques-240-bottes-240-impermeables-240-parapluies-240-stylos-et-240-badges.pdf',
        "description": "Nous recherchons des fournisseurs pour des équipements essentiels, notamment des balances, des bottes, des imperméables et des stylos. Ce projet garantit la qualité de nos opérations.",
        "requirements": `
            - Capacité financière :
                - Accès à des avoirs liquides ou lignes de crédit d'au moins 30 000 000 BIF.
                - Chiffre d'affaires annuel moyen d'au moins 40 000 000 BIF sur les cinq dernières années.
            - Capacité technique :
                - Livraison des articles dans un délai maximum d'un mois après la signature du contrat.
                - Fournitures neuves conformes aux spécifications de qualité.
                - Preuve d'expérience avec au moins deux contrats similaires des trois dernières années, d'une valeur minimum de 30 000 000 BIF chacun.
        `,
        "datePublication": "18/12/2024",
        "dateFin": "4/02/2025 à 10h00"
    },
    {
        "title": "Avis de manifestation d'intérêt pour des analyses thématiques",
        "link": '/documents/jobs/Avis-de-manifestation-dinteret-Analyses-Thematiques-24.05.2024.pdf',
        "description": "Nous recherchons des chercheurs qualifiés pour mener des analyses sur les enquêtes concernant le minimum des services de santé au Burundi et la sécurité alimentaire et nutritionnelle. Ce projet vise à recueillir les meilleures pratiques pour renforcer les politiques de santé publique.",
        "requirements": `
            - Expérience d'au moins trois ans dans des recherches similaires ;
            - Expertise en analyse statistique et en interprétation de données ;
            - Excellente maîtrise du français et de l'anglais.
        `,
        "datePublication": "24/05/2024",
        "dateFin": "7/06/2024 à 12h00"
    },
    {
        "title": "Avis de recrutement d'un consultant international statisticien",
        "link": '/documents/jobs/TDR-POUR-RECRUTEMENT-DUN-CONSULTANT-STATISTICIEN-DU-RGAE-SPECIALISTE-DANS-LES-ENQUETES-ET-RECENSEMENTS-AGRICOLES.pdf',
        "description": "Nous recherchons un consultant international pour diriger l'analyse statistique des recensements agricoles. Ce rôle exige une connaissance approfondie des méthodes statistiques modernes et la capacité à traduire des données complexes en recommandations pratiques.",
        "requirements": `
            - Diplôme en statistique ou domaine connexe ;
            - Au moins 10 ans d'expérience dans des projets d'enquête agricole ;
            - Maîtrise parfaite du français et de l'anglais est un atout.
        `,
        "datePublication": "2/02/2024",
        "dateFin": "28/02/2024 à 10h00"
    },
];

function RecruitmentPage() {
    const [visibleCount, setVisibleCount] = useState(4);
    const [filteredJobs, setFilteredJobs] = useState(jobOpenings);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const updatedJobs = jobOpenings.map(job => {
            // Essayer de parser la date de fin avec différents formats
            let endDate = moment(job.dateFin, 'DD/MM/YYYY à HH:mm');
            if (!endDate.isValid()) {
                endDate = moment(job.dateFin, 'DD/MM/YYYY');
            }
            const isExpired = moment().isAfter(endDate);
            const duration = moment.duration(endDate.diff(moment()));
            const daysRemaining = isExpired ? null : Math.floor(duration.asDays());
            const hoursRemaining = isExpired ? null : duration.hours();

            return {
                ...job,
                isExpired,
                daysRemaining,
                hoursRemaining,
            };
        });
        setFilteredJobs(updatedJobs);
    }, []);

    const handleShowMore = () => {
        setVisibleCount((prevCount) => prevCount + 2);
    };

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredBySearchTerm = filteredJobs.filter(job =>
        job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const theme = createTheme({
        palette: {
            primary: { main: '#388E3C' },
            secondary: { main: '#f50057' },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: { borderRadius: '8px', textTransform: 'none', fontWeight: 'bold' },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        transition: 'transform 0.2s ease-in-out',
                        '&:hover': { transform: 'scale(1.03)', boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)' },
                    },
                },
            },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
                <NavigationBar />
                <Container maxWidth="lg" style={{ paddingTop: '60px' }}>
                    <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
                        Opportunités de recrutement et appels d'offres
                    </Typography>
                    <Divider style={{ margin: '20px 0' }} />
                    <Typography variant="body1" align="justify" gutterBottom>
                        L'Institut National de la Statistique du Burundi propose diverses opportunités, y compris des offres d'emploi et des appels d'offres. Nous vous invitons à explorer ces possibilités qui contribuent au développement statistique et à la recherche dans notre pays.
                    </Typography>

                    {/* Barre de recherche */}
                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                        <TextField
                            variant="outlined"
                            placeholder="Rechercher un poste..."
                            value={searchTerm}
                            onChange={handleSearch}
                            fullWidth
                        />
                        <IconButton type="submit" aria-label="search">
                            <SearchIcon />
                        </IconButton>
                    </Box>

                    <Grid container spacing={1} style={{ marginTop: '10px' }}>
                        {filteredBySearchTerm.slice(0, visibleCount).map((job, index) => (
                            <Grid item xs={12} sm={6} md={6} key={index}>
                                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>
                                        {/* Titre avec lien */}
                                        <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                                            <a
                                                href={job.link}
                                                style={{ textDecoration: 'none', color: 'inherit' }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <DownloadIcon /> {job.title}
                                            </a>
                                        </Typography>

                                        {/* Description */}
                                        <Typography variant="body1" component="div" style={{ color: '#555', marginBottom: '10px', fontSize: '0.9rem' }}>
                                            {job.description}
                                        </Typography>

                                        {/* Exigences - Vérifier l'existence */}
                                        {job.requirements && (
                                            <Typography variant="body2" color="textSecondary">
                                                Exigences : <br />
                                                {job.requirements.split('\n').map((line, i) => (
                                                    <span key={i}>{line}<br /></span>
                                                ))}
                                            </Typography>
                                        )}

                                        {/* Lien de postulation */}
                                        {job.linkPost && job.titlePost && (
                                            <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '5px', color: theme.palette.primary.main }}>
                                                <a
                                                    href={job.linkPost}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        marginTop: "16px",
                                                        marginBottom: "32px",
                                                        padding: "8px 16px",
                                                        display: "inline-block",
                                                        color: "white",
                                                        textDecoration: "none",
                                                        borderRadius: "8px",
                                                        backgroundColor: "#388E3C",
                                                        transition: "background-color 0.3s ease",
                                                    }}
                                                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#388E3C")}
                                                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#388E3C")}
                                                >
                                                    {job.titlePost}
                                                </a>
                                            </Typography>
                                        )}

                                        {/* Dates */}
                                        <Typography variant="body2" color="textSecondary" style={{ marginTop: '5px' }}>
                                            Date de publication : {job.datePublication}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary" style={{ marginTop: '5px' }}>
                                            Date de fin : {job.dateFin}
                                        </Typography>
                                        {job.dateOuverture && (
                                            <Typography variant="body2" color="textSecondary" style={{ marginTop: '5px' }}>
                                                Date d'ouverture des offres : {job.dateOuverture}
                                            </Typography>
                                        )}

                                        {/* Lien TDR */}
                                        {job.linkTdrs && job.titleTdrs && (
                                            <Typography variant="h6" component="div" style={{ marginBottom: '5px', color: theme.palette.primary.main }}>
                                                <a
                                                    href={job.linkTdrs}
                                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {job.titleTdrs}
                                                </a>
                                            </Typography>
                                        )}

                                        {/* Contact */}
                                        {job.Titrecontact && job.contact && (
                                            <Typography variant="body2" color="textSecondary" style={{ marginTop: '5px' }}>
                                                {job.Titrecontact} {job.contact}
                                            </Typography>
                                        )}

                                        {/* Affichage expiration */}
                                        {!job.isExpired && job.daysRemaining !== null && (
                                            <Typography variant="body2" style={{ color: 'green', marginTop: '10px' }}>
                                                Il reste {job.daysRemaining} jour(s) et {job.hoursRemaining} heure(s).
                                            </Typography>
                                        )}
                                        {job.isExpired && (
                                            <Typography variant="body2" color="red" style={{ marginTop: '10px' }}>
                                                Cette offre est expirée.
                                            </Typography>
                                        )}
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                    {/* Bouton "Plus de postes" */}
                    {visibleCount < filteredBySearchTerm.length && (
                        <Button
                            onClick={handleShowMore}
                            style={{
                                marginTop: '20px',
                                backgroundColor: theme.palette.primary.main,
                                color: 'white',
                            }}
                        >
                            plus de postes
                        </Button>
                    )}
                </Container>
                <br />
                <br />
                <Footer />
            </div>
        </ThemeProvider>
    );
}

export default RecruitmentPage;